import { FC } from 'react';
import { useRecognitionAchievements } from 'store/recognition-achievements';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'multiple'
>;

export const AchievementsFilter: FC<Props> = (props) => {
  const { data: achievements, isLoading } = useRecognitionAchievements();

  return (
    <SelectFilter
      {...props}
      options={
        achievements?.map((achievement) => ({
          key: achievement.id,
          label: achievement.name,
        })) ?? []
      }
      loadingOptions={isLoading}
      multiple
    />
  );
};
